module.exports = __webpack_public_path__ + "static/media/Yala_map.b192fbb0.png";